<template>
  <div>
    <RevButtonBase
      class="flex shrink cursor-pointer items-center justify-start"
      @click="isOpen = !isOpen"
    >
      <IconChevronDown
        :class="{ 'rotate-180': isOpen }"
        data-test="chevron-icon"
      />
      <p class="caption-link">
        {{ title }}
      </p>
    </RevButtonBase>

    <div v-show="isOpen">
      <p class="caption pl-24">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconChevronDown } from '@ds/icons/IconChevronDown'

const isOpen = ref(false)

defineProps<{
  title: string
  description: string
}>()
</script>
